import { render, staticRenderFns } from "./AddCompanyDialog.vue?vue&type=template&id=11d146c6&"
import script from "./AddCompanyDialog.vue?vue&type=script&lang=js&"
export * from "./AddCompanyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports